import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "./setup.css";
import { useNavigate } from "react-router-dom";
import MarginLogo from "../../assets/icons/margin.svg";
import { csvUploadListBackDetails, mappingListBackDetails, sellerCarrierBackDetails, sellerCarrierServiceBackDetails } from "../../store/actions";
import { fundmanagementBackDetails } from "../../store/actions/fundManagement";
import { baseRatecardListBackDetails, sellerRatecardListBackDetails } from "../../store/actions/rateCard";
import { marketPlaceBackDetails } from "../../store/actions/marketplace.action";
import { marginConfigBackDetails } from "../../store/actions/employee";
import { checkPermission } from "../../config/utils";
import { FEATURE_UPLOADS, featureSubmodule, settings } from "../../constant";

export function Setup(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { employeePermissions } = props;
  const backDetailsArray = [
    mappingListBackDetails,
    fundmanagementBackDetails,
    baseRatecardListBackDetails,
    sellerRatecardListBackDetails,
    csvUploadListBackDetails,
    sellerCarrierBackDetails,
    sellerCarrierServiceBackDetails,
    marketPlaceBackDetails,
    marginConfigBackDetails,
  ];

  const handleBackDetails = () => {
    backDetailsArray.forEach(action => {
      dispatch(action({}));
    });
  };

  const [cardList] = useState([
    {
      name: "CSV Mapping",
      icon: "fa fa-map-signs",
      color: "#0000ff69",
      path: "/csvList",
      module: FEATURE_UPLOADS,
      subModule: 14
    },
    {
      name: "Fund Management",
      icon: "fa fa-usd",
      color: "#4BBBD3",
      path: "/fundManagement",
      module: settings,
      subModule: 15
    },
    {
      name: "Rate Card",
      icon: "fa fa-money",
      color: "#D04545",
      path: "/rateCard",
      module: settings,
      subModule: 16
    },
    {
      name: "CSV Upload",
      icon: "fa fa-file-excel-o",
      color: "#0000ff69",
      path: "/csvUpload",
      module: FEATURE_UPLOADS,
      subModule: 17
    },
    {
      name: "API Key Generation",
      icon: "fa fa-key",
      color: "#0000ff69",
      path: "/generate-key",
      module: settings,
      subModule: 18
    },
    {
      name: "Service Configuration",
      icon: "fa fa-ship",
      color: "#0000ff69",
      path: "/manage-carriers",
      module: settings,
      subModule: 19
    },
    {
      name: "Marketplace Integration",
      icon: "fa fa-globe",
      color: "#0000ff69",
      path: "/marketplace-integration",
      module: settings,
      subModule: 20
    },
    {
      name: "Margin Configuration",
      icon: "fa fa-globe",
      color: "#0000ff69",
      path: "/margin-configuration",
      module: settings,
      subModule: 21
    },
    {
      name: "Configuration",
      icon: "fa fa-sliders",
      color: "#0000ff69",
      path: "/Configuration",
      module: settings,
      subModule: 22
    },
    {
      name: "Role Permissions",
      icon: "fa fa-lock",
      color: "#00ff69",
      path: "/permissions",
      module: settings,
      subModule: 29,
    },
    {
      name: "Carrier Adjustments",
      icon: "fa fa-area-chart",
      color: "#00ff69",
      path: "/carrier-adjustments",
      module: settings,
      subModule: 29,
    },
    {
      name: "Email Templates",
      icon: "fa fa-envelope",
      color: "#0000ff69",
      path: "/email-templates",
      module: settings,
      subModule: 20,
    },
    {
      name: "Dropshipping Configuration",
      icon: "fa fa-exchange",
      color: "#28a745",
      path: "/dropship-settings",
      module: settings,
      subModule: 20,
    },
    {
      name: "Dropship Margin Config",
      icon: "fa fa-percent",
      color: "#28a745",
      path: "/dropship-margin-config",
      module: settings,
      subModule: 21,
    }
  ]);

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading">Settings</div>
        <div className="container-fluid">
          <div className="cus-page-content-sec">
            <div className="content-container">
              <div className="cards setup-container">
                {cardList.map((card) => (
                  <React.Fragment key={card.subModule}>
                    {(card.name === "Rent Configuration" || checkPermission(card.module, card.subModule, '', featureSubmodule, employeePermissions)) && (
                      <div
                        className="setup-card"
                        onClick={() => {
                          navigate(card.path);
                          handleBackDetails();
                        }}
                      >
                        <div className="icon">
                          {card.path === '/margin-configuration' ? (
                            <img alt="" className="cus-sm-icon-cls" src={MarginLogo} style={{ maxWidth: '30px' }} />
                          ) : (
                            <i className={card.icon} />
                          )}
                        </div>
                        <div className="txt-name">{card.name}</div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
